import useSWR from "swr";
import { useSWRFetcher } from "./useSWRFetcher";
import { environment } from "../config/environment";
import { SearchResponseTypeModel, InvoiceSummaryResponse, InvoiceTotalInfoModel } from "@attelas/shared";
import { usePayable } from "./usePayable";
import { useMemo } from "react";

type SearchParams = {
  id: string;
  type: SearchResponseTypeModel;
};

export const usePayablesBySupplierOrId = (searchParams: SearchParams | null | undefined) => {
  const { id, type } = searchParams ?? {};
  const fetcher = useSWRFetcher();

  const { data, isLoading, error } = useSWR<InvoiceSummaryResponse>(
    type === "Contact" ? `${environment.apiUrl}/api/invoices/suppliers/${id}/summary?isAuthorizedOnly=false` : null,
    (url: string) => fetcher(url),
    {}
  );

  const { payable, isLoading: isPayableLoading, isError } = usePayable(type === "Invoice" ? id : null);

  const invoices = useMemo(() => {
    if (type === "Contact") {
      return data?.invoices ?? [];
    }

    if (type === "Invoice" && payable) {
      return [payable.invoiceDetails];
    }

    return [];
  }, [data, payable, type]);

  const totalInfo: InvoiceTotalInfoModel | null = useMemo(() => {
    if (type === "Contact") {
      return {
        totalAmount: data?.totalAmount ?? 0,
        totalDueAmount: data?.totalDueAmount ?? 0,
        link: data?.link ?? "",
      };
    }
    return null;
  }, [data, type]);

  return {
    invoices,
    totalInfo,
    supplierId: type === "Contact" ? id : payable?.supplierDetails.id,
    isLoading: type === "Contact" ? isLoading : isPayableLoading,
    isError: type === "Contact" ? !!error : isError,
  };
};
